import { render, staticRenderFns } from "./ConfirmTooltip.vue?vue&type=template&id=4047d616"
import script from "./ConfirmTooltip.vue?vue&type=script&lang=js"
export * from "./ConfirmTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports